var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sd-map-control full-height full-width"},[_c('div',{ref:"mapControl",staticClass:"full-height full-width",staticStyle:{"width":"100%"},attrs:{"id":"map-container"}}),_c('div',{staticClass:"map-component"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }